export default __webpack_public_path__ + "static/media/arrow-up-dark.777d3dd3.svg";